import { render, staticRenderFns } from "./drawer-panel.vue?vue&type=template&id=23d5a4ae&"
import script from "./drawer-panel.vue?vue&type=script&lang=js&"
export * from "./drawer-panel.vue?vue&type=script&lang=js&"
import style0 from "./drawer-panel.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "drawer-panel.vue"
export default component.exports